import * as def from '@/definitions'
import { ColorConstruct } from '@/utilityModels/colorConstruct'
import { Layer } from './layer';
import { ObjectLayer } from './objectLayer';

export class TextLayer extends ObjectLayer
{
    public static PLACEHOLDER = "文字を入力";
    
    public get layerType() : string { return "text"; }

    // 文字
    private _text : string = "";
    public get text() : string { return this._text; }
    public set text(text : string) { this._text = text; }

    // 不透明度
    private _opacity : number = 100;
    public get opacity() : number { return this._opacity; }
    public set opacity(opacity : number) { this._opacity = opacity; }

    // 編集中フラグ
    public inEdit : boolean = false;

    // 文字の編集位置
    public startPosition : number = 0;
    public endPosition : number = 0;

    // 直前の編集位置
    public lastStartPosition : number = 0;
    public lastEndPosition : number = 0;

    // 文字の選択位置
    public selectedLineIndex : number = 0;
    public selectedCharacterIndex : number = 0;
    public isAfterSelected : boolean = false;

    // positionを元にlineIndex, characterIndexを取得
    // positionの直前にある文字について取得する。
    // position == 0の場合は最初の文字を取る。
    // lineIndex : [行index]
    // characterIndex : [文字index]
    // isFirstInLine : [行の先頭かどうか]
    public getLineAndCharacterIndexFromPosition(position : number)
    {
        // 改行文字で分割
        var pos = 0;
        var lines = this.text.split(/\r?\n/g);
        for(var l = 0; l < lines.length; ++l)
        {
            var line = lines[l];
            if(pos == position)
            {
                return { lineIndex : l, characterIndex : 0, isFirstInLine : true };
            }
            for(var c = 0; c < line.length; ++c)
            {
                pos++;
                if(pos == position)
                {
                    return { lineIndex : l, characterIndex : c, isFirstInLine : false };
                }
            }
            pos++;
        }
        return { lineIndex : 0, characterIndex : 0, isFirstInLine : true };
    }

    // positionの範囲を元に、lineIndex, characterIndexの配列を取得
    public getLineAndCharacterIndexArrayFromPositionRange(startPosition : number, endPosition : number) : Array<{ lineIndex : number, characterIndex : number }>
    {
        var array = new Array();
        // 改行文字で分割
        var pos = 0;
        var lines = this.text.split(/\r?\n/g);
        for(var l = 0; l < lines.length; ++l)
        {
            var line = lines[l];
            for(var c = 0; c < line.length; ++c)
            {
                if(startPosition <= pos && pos < endPosition)
                {
                    // 開始位置〜終了位置
                    array.push({ lineIndex : l, characterIndex : c });
                }
                pos++;
            }

            pos++;
        }
        return array;
    }

    // lineIndex, characterIndexを元にpositionを取得
    public getPositionFromLineAndCharacterIndex(lineIndex : number, characterIndex : number, isAfter : boolean)
    {
        // 改行文字で分割
        var pos = 0;
        var lines = this.text.split(/\r?\n/g);
        for(var l = 0; l < lines.length; ++l)
        {
            var line = lines[l];
            for(var c = 0; c < line.length; ++c)
            {
                if(isAfter) { pos++; }
                if(l == lineIndex && c == characterIndex)
                {
                    return pos;
                }
                if(!isAfter) { pos++; }
            }
            if(l == lineIndex && 0 == characterIndex)
            {
                return pos;
            }
            pos++;
        }

        return 0;
    }

    // テキストを変更する
    // このレイヤーを継承したレイヤーで個別動作が必要な場合overrideすること
    public changeText(text : string)
    {
        this.text = text;
    }

    // テキストのバックアップのためのオブジェクトを取得する
    // このレイヤーを継承したレイヤーで個別動作が必要な場合overrideすること
    public getBackupTextObject() : any
    {
        return null;
    }

    // テキストのバックアップのためのオブジェクトを適用する
    // このレイヤーを継承したレイヤーで個別動作が必要な場合overrideすること
    public setBackupTextObject(object : any)
    {
        // nothing
    }

    // 複製
    public clone()
    {
        var cloned = new TextLayer();
        this.cloneParameter(cloned);
        return cloned;
    }

    public cloneParameter(layer : TextLayer)
    {
        layer.text = this._text;
        layer.opacity = this._opacity;
        
        super.cloneParameter(layer);
    }

    // JSON
    public toJSON()
    {
        var jsonObj = {};
        jsonObj = this.saveParameterToJson(jsonObj);
        return jsonObj;
    }

    public saveParameterToJson(jsonObject)
    {
        jsonObject.text = this._text;
        jsonObject.opacity = this._opacity;

        jsonObject = super.saveParameterToJson(jsonObject);

        return jsonObject;
    }

    public static createFromJsonData(jsonData : any) : TextLayer
    {
        var layer = new TextLayer();
        layer.loadParameterFromJson(jsonData);
        return layer;
    }

    public loadParameterFromJson(jsonData)
    {
        if(jsonData.text != null) { this._text = jsonData.text; }
        if(jsonData.opacity != null) { this._opacity = jsonData.opacity; }

        super.loadParameterFromJson(jsonData);
    }
}
